<div class="container py-5 bg-star">
    <div class="row">
        <div class="col-md-6 m-auto">
            <div class="signup-form" *ngIf="invitation">
                
                <form [formGroup]="coachForm" (ngSubmit)="onSigup(coachForm)">
                    
                    <h5 class="mb-4">Hello, {{invitation.connection_email}}!</h5>
                    <p>
                        NOT YOU? <a routerLink="['/']">CLICK HERE</a> TO LEAVE THIS PAGE. <br/>
                    </p>
                    <p>
                    YOU WERE INVITED BY {{invitation.owner_email | uppercase}} TO JOIN FORGE - CHEERLEADING SKILL BUILDING WEBSITE AS A ACoachTHLETE.

                    Coach registration is free. You will have access to the skill building videos shared with you by your gymowners.
                    </p>
                    TO ACTIVATE YOUR PROFILE PLEASE ENTER A PASSWORD YOU WILL BE USING TO ENTER THIS WEBSITE:

                    <div class="form-group">
                        <label for="" class="form-label">Password you will be using to enter this Website:</label>
                        <input type="text" class="form-control" formControlName="password">
                        <div class="invalid-feedback d-block"
                            *ngIf="(f1['password'].errors?.['required'] || f1['password'].errors?.['minlength']) && (f1['password'].dirty || f1['password'].touched)">
                            Please fill 8 character long password.
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="checkbox" formControlName="agree" [checked]="f1['agree'].value" value="1" name="agree" id="agree">
                        <label for="agree" class="d-inline-block ms-2 form-label">I agree to the Terms and Conditions and Privacy Policy of this Website.</label>
                        <div class="invalid-feedback d-block"
                            *ngIf="(f1['agree'].errors?.['required']) && (f1['agree'].dirty || f1['agree'].touched)">
                            Please agree to our terms and conditions.
                        </div>
                    </div>
                    
                    <div class="d-flex justify-content-end mt-3">
                        <button type="submit" class="btn btn-gold mt-2 ml-auto">Sign Up <i *ngIf="formSubmitting" class="fa fa-spinner fa-spin"></i></button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>